//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Tooltip,
  Button,
} from '@mui/material';

 import {
  SubscriptionsOutlined,
} from '@mui/icons-material';

// === API ===
import { onTaskMonitorStatus, removeListener, subscribeTaskQueue, unsubscribeTaskQueue } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function TaskMonitor() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const [ monitoring     , setMonitoring     ] = useState( false );
  const [ isStopDisabled , setIsStopDisabled ] = useState( false );

  const _styles = {
    toggle: {
      height : '40px',
      margin: '0 0.5rem',
      backgroundColor: monitoring ? theme.palette.primary.main : theme.palette.success.main,
      '&:hover': {
        backgroundColor: monitoring ? theme.palette.primary.dark : theme.palette.success.dark,
      },
    }
  }

  //#endregion

  //#region [EFFECT]

  // ===

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleTaskMonitoring(state) {
      //-----------------------------------------------------------------
      setMonitoring(state);
    }

    onTaskMonitorStatus( handleTaskMonitoring );

    return () => {
      removeListener( 'TASK-MONITORING' , handleTaskMonitoring );
    }

  }, [])

  // ===

  useEffect(() => {
    if (!monitoring) {
      unsubscribeTaskQueue();
      return;
    }

    setIsStopDisabled(true);
    setTimeout(() => setIsStopDisabled(false), 1000);

    subscribeTaskQueue();
  }, [monitoring]);

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Tooltip title={ monitoring ? 'Stop Monitoring' : 'Start Task Monitoring' }>
        <Button
          name='toggle_monitoring_btn'
          sx={_styles.toggle}
          variant='contained'
          onClick={() => setMonitoring( !monitoring ) }
          disabled={isStopDisabled}
        >
          <SubscriptionsOutlined />
        </Button>
      </Tooltip>
    );
  }

  //#endregion

  return display();
}
